const deployWorkspace = {
  bindings: {
    workspace: '<',
    mode: '<',
    onSubmit: '&',
    onCancel: '&'
  },
  templateUrl:
    '/modules/pis-tool/workspaces/workspace-modal/deploy-workspace/deploy-workspace.html',
  controller: 'DeployWorkspaceController',
};

angular
  .module('pis-tool.module')
  .component('deployWorkspace', deployWorkspace);
